module.exports = __webpack_public_path__ + "media/images/product_lines/pdf-ddc6bdf873e534cfa3f443577e170e4b.svg";